import './../../DashboardActivityV2/DashboardActivityV2.scss'
import './RecentSignup.scss'

const RecentSignup = () => {
  const transactions = [
    {
      user: 'Tunde Bakare',
      email: 'tunde.bakare@example.com',
      location: 'Lagos',
      product: 'BoostXpress',
      date: '2m ago',
    },
    {
      user: 'Tunde Bakare',
      email: 'tunde.bakare@example.com',
      location: 'Lagos',
      product: 'BoostXpress',
      date: '2m ago',
    },
    {
      user: 'Tunde Bakare',
      email: 'tunde.bakare@example.com',
      location: 'Lagos',
      product: 'BoostXpress',
      date: '2m ago',
    },
    {
      user: 'Tunde Bakare',
      email: 'tunde.bakare@example.com',
      location: 'Lagos',
      product: 'BoostXpress',
      date: '2m ago',
    },
    {
      user: 'Tunde Bakare',
      email: 'tunde.bakare@example.com',
      location: 'Lagos',
      product: 'BoostXpress',
      date: '2m ago',
    },
  ]

  const getStatusClass = (status: string) => {
    switch (status.toLowerCase()) {
      case 'success':
        return 'statusSuccess'
      case 'pending':
        return 'statusPending'
      case 'failed':
        return 'statusFailed'
      case 'active':
        return 'statusActive'
      default:
        return ''
    }
  }

  return (
    <div className={'card border-0 recent-signup-card'}>
      <div className={'cardHeader'}>
        <h4 className={'cardTitle'}> Recent Signup</h4>
      </div>
      <div className='tableWrapper'>
        <table className={'table'}>
          <tbody>
            {transactions.map((tx, index) => (
              <tr key={index}>
                <td className='position-relative'>
                  <span className='user-avarter-text mt-4'>CO</span>
                </td>
                <td className={'userCell'}>
                  <div className='user-name'>{tx.user}</div>
                  <div className='user-info'>
                    {tx.email} · {tx.location}
                  </div>
                </td>
                <td className={'typeCell text-end'}>
                  <div className='user-product'>{tx.product}</div>
                  <div className='user-date'>{tx.date}</div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default RecentSignup
